import FilterDates from "./FilterDates";
import FilterOperatorLine from "./FilterOperatorLine";
import FilterSearch from "./FilterSearch";
import FilterSelects from "./FilterSelects";
import FilterStatusTabs from "./FilterStatusTabs";
import useFilterParams from "./useFilterParams";

// The one filter bar of the reservations list. It only reads and writes the URL (see
// reservationFilters.ts); the list refetches when the URL changes. Search on top, status as
// tabs, and every other filter as a chip that shows its applied value and clears with its ×,
// so nothing that narrows the list is ever out of sight.
const ReservationFilterBar = () => {
  const { hasFilters, clearAll } = useFilterParams();

  return (
    <div className="lg:max-w-[75%] mx-auto mb-4 flex flex-col gap-3">
      <FilterSearch />
      <FilterStatusTabs />
      <div className="flex flex-wrap items-center gap-2">
        <FilterDates />
        <FilterOperatorLine />
        <FilterSelects />
        {hasFilters && (
          <button
            type="button"
            onClick={clearAll}
            className="ml-auto px-2 py-1.5 text-sm text-primary hover:underline"
          >
            Pastro filtrat
          </button>
        )}
      </div>
    </div>
  );
};

export default ReservationFilterBar;
